import classnames from 'classnames';
import { useCallback, useRef } from 'react';

import { EditorQuickRepliesDropdown } from 'components/editorQuickRepliesDropdown';
// eslint-disable-next-line no-restricted-imports
import RichTextFieldImpl from 'components/shared/util/richTextField/components/RichTextField';
// eslint-disable-next-line no-restricted-imports
import RichTextField from 'components/shared/util/richTextField/containers/richTextField';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { BulkModalActionType } from '../../types/conversationsBulkModal.types';

import styles from './conversationsBulkModalTextEditor.module.scss';

type ConversationsBulkModalTextEditorProps = {
  type: Extract<BulkModalActionType, 'send_reply' | 'add_internal_note'>;
  onChange: (html: string, plain: string) => void;
};

export const ConversationsBulkModalTextEditor = ({
  type,
  onChange,
}: ConversationsBulkModalTextEditorProps): JSX.Element => {
  const editorRef = useRef<RichTextFieldImpl>(null);
  const { writeHtmlEmail } = useFeatureFlag(['write-html-email']);

  const handleRenderTemplate = useCallback(
    ({ content }: { content: string }) => {
      return Promise.resolve({ data: { rendered_content: content } });
    },
    [],
  );

  const getRenderContext = useCallback(() => {
    return {
      context: {},
    };
  }, []);

  const handleChange = useCallback(() => {
    onChange(
      editorRef.current?.getText() || '',
      editorRef.current?.getPlainText() || '',
    );
  }, [onChange]);

  return (
    <div
      className={classnames(styles.container, {
        [styles.containerInternalNote]: type === 'add_internal_note',
      })}
    >
      {/* TODO: [TEAMS-8618] use the new editor once it's implemented */}
      <RichTextField
        // NOTE: Do it like this because there's something wrong with the typing.
        {...{ hasFFWriteHTMLEmail: writeHtmlEmail }}
        ref={editorRef}
        renderTemplate={handleRenderTemplate}
        channel="bulk"
        placeholder={
          type === 'add_internal_note'
            ? 'Type your internal note...'
            : 'Type your message...'
        }
        onChange={handleChange}
        toolbarAddons={
          <EditorQuickRepliesDropdown getRenderContext={getRenderContext} />
        }
      />
    </div>
  );
};
